export default "__VITE_ASSET__DrFJsfiX__"